import React, { useState } from "react";
import "./styles.scss";
import { NavLink } from "react-router-dom";
import { ReactComponent as EditIcon } from "../../../../public/icons/NavSettings-icons/edit_icon_outlined.svg";
import { ReactComponent as SociallMediaIcon } from "../../../../public/icons/NavSettings-icons/fork.svg";
import { ReactComponent as KeyIcon } from "../../../../public/icons/NavSettings-icons/key_outlined.svg";
import UnsubscribeModal from "./UnsubscribeModal";
import UnsubscribeConfimModal from "./UnsubscribeConfimModal";
import DeletionModal from "./DeletionModal";
import DeletionConfimModal from "./DeletionConfimModal";
import { isMobile } from "react-device-detect";

export default ({ user }) => {
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDeletionModal, setShowDeletionUnsubscribeModal] = useState(false);
  const [showDeletionConfirmModal, setShowDeletionConfirmModal] = useState(false);

  const showConfirmation = () => {
    setShowConfirmModal(true);
  };

  const showSubscribtionModal = () => {
    setShowUnsubscribeModal(true);
    setShowConfirmModal(false);
  };

  const showDeletionConfirmation = () => {
    setShowDeletionConfirmModal(true);
  };

  const showDeletionSubscribtionModal = () => {
    setShowDeletionUnsubscribeModal(true);
    setShowDeletionConfirmModal(false);
  };

  return (
    <>
      <div className="nav flex-column nav-pills">
        <h1>
          <b>Settings</b>
        </h1>
        <NavLink exact className="hudl-settings-link" to="/settings">
          <EditIcon className="mr-4" />
          Edit Account
        </NavLink>
        <NavLink exact className="hudl-settings-link" to="/settings/social-media">
          <SociallMediaIcon className="mr-4" />
          Social Media
        </NavLink>
        <NavLink exact className="hudl-settings-link" to="/settings/change-password">
          <KeyIcon className="mr-4" />
          Change Password
        </NavLink>

        {user.is_subscribed_to_tipjar ? (
          <button className="btn btn-danger btn-sm mt-2" onClick={showConfirmation}>
            CANCEL TIPJAR
          </button>
        ) : null}

        {!isMobile && (
          <>
            {user.is_subscribed_to_primo ? (
              <button className="btn btn-danger btn-sm mt-2" onClick={showConfirmation}>
                CANCEL PRIMO
              </button>
            ) : null}

            <button className="btn btn-danger btn-sm mt-2" onClick={showDeletionConfirmation}>
              Delete My Account
            </button>
          </>
        )}
      </div>
      {showUnsubscribeModal && <UnsubscribeModal show={showUnsubscribeModal} hide={() => setShowUnsubscribeModal(false)} />}

      {showConfirmModal && (
        <UnsubscribeConfimModal show={showConfirmModal} showSubscribtionModal={showSubscribtionModal} hide={() => setShowConfirmModal(false)} />
      )}

      {showDeletionModal && <DeletionModal show={showDeletionModal} hide={() => setShowDeletionConfirmModal(false)} />}

      {showDeletionConfirmModal && (
        <DeletionConfimModal
          show={showDeletionConfirmModal}
          showDeletionSubscribtionModal={showDeletionSubscribtionModal}
          hide={() => setShowDeletionConfirmModal(false)}
          user={user}
        />
      )}
    </>
  );
};
